import { Box, IconButton, Typography, useTheme } from "@mui/material";
import {
  Close as CloseIcon,
  Description as DescriptionIcon,
  Videocam as VideocamIcon,
} from "@mui/icons-material";
import { FILE_FORMATS, IMAGE_FORMATS } from "../../../../utils/constants";
import { getExtensionFile } from "../../../../utils/string";
import {
  ATTACHMENT_CHIP_VARIANTS,
  getAttachmentChipStyles,
} from "./attachmentChipTheme";

const AttachmentChip = ({
  url,
  fileName,
  variant = ATTACHMENT_CHIP_VARIANTS.LIGHT,
  onRemove,
}) => {
  const theme = useTheme();
  const styles = getAttachmentChipStyles({ variant, theme });
  const extension = getExtensionFile(url || fileName);
  const isImage = IMAGE_FORMATS.includes(extension);
  const isDocument = FILE_FORMATS.includes(extension);

  return (
    <Box sx={styles.container}>
      {isImage ? (
        <Box component="img" src={url} alt={fileName} sx={styles.thumbnail} />
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 22,
            height: 22,
            flexShrink: 0,
            color: styles.label.color,
          }}
        >
          {isDocument ? (
            <DescriptionIcon sx={{ fontSize: 18 }} />
          ) : (
            <VideocamIcon sx={{ fontSize: 18 }} />
          )}
        </Box>
      )}
      <Typography variant="caption" noWrap sx={styles.label}>
        {fileName}
      </Typography>
      {onRemove ? (
        <IconButton onClick={onRemove} sx={{ p: 0 }} aria-label="Remove file">
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      ) : null}
    </Box>
  );
};

export default AttachmentChip;
